<template>
  <header
    class="barocare-b2c-header"
    :class="{'navigation': true, 'scrolled': isScrolled}"
    id="header"
  >
    <div class="container">
      <h1 id="logo">
        <a @click.prevent="scrollToTop" href="#home">
          <img src="../../assets/pc_barocare_b2c/logo-white.png" alt="바로돌봄" class="logo-white" />
          <img src="../../assets/pc_barocare_b2c/logo-primary.png" alt="바로돌봄" class="logo-primary" />
        </a>
      </h1>
      <ul class="gnb">
        <li><a @click.prevent="scrollToSection($event, 'barocare-b2c-service-intro', +50)" href="#barocare-b2c-service-intro">서비스 소개</a></li>
        <li><a @click.prevent="scrollToSection($event, 'barocare-b2c-service-use', -40)" href="#barocare-b2c-service-use">이용 방법</a></li>
        <li><a @click.prevent="scrollToSection($event, 'barocare-b2c-inquiry', -116)" href="#barocare-b2c-inquiry">자주 묻는 질문</a></li>
      </ul>
      <div class="btn-area">
        <a
          href="http://pf.kakao.com/_xhcxkQG/friend"
          target="_blank" title="새창"
          class="btn-partnership"
        >진료 예약 하기</a>
      </div>
    </div>
  </header>       
</template>

<script>
export default {
  name: 'BarocareB2cHeader',
  data() {
    return {
      isScrolled: false
    };
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 891) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }
    },
    scrollToTop(event) {
      window.history.pushState({}, '', event.target.closest('a').href);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    scrollToSection(event, sectionId, offset) {
      const section = document.getElementById(sectionId);
      if (section) {
        const y = section.getBoundingClientRect().top + window.pageYOffset + offset;
        
        window.history.pushState({}, '', event.target.closest('a').href);
        window.scrollTo({
          top: y,
        });
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/pc_barocare_b2c/BarocareB2cHeader.vue